export const LOAD_FEEDBACK_REQUEST = 'LOAD_FEEDBACK_REQUEST';
export const LOAD_FEEDBACK_SUCCESS = 'LOAD_FEEDBACK_SUCCESS';
export const LOAD_FEEDBACK_FAILURE = 'LOAD_FEEDBACK_FAILURE';
export const LOAD_SUPPLEMENTS_FEEDBACK_FAILURE = 'LOAD_SUPPLEMENTS_FEEDBACK_FAILURE';

export const RECEIVE_CONSULTATION_SURVEY_INFOS = 'RECEIVE_CONSULTATION_SURVEY_INFOS';
export const RECEIVE_ORDER_INFOS = 'RECEIVE_ORDER_INFOS';
export const RECEIVE_SUPPLEMENTS_ORDER_INFOS = 'RECEIVE_SUPPLEMENTS_ORDER_INFOS';

export const SAVE_FEEDBACK_REQUEST = 'SAVE_FEEDBACK_REQUEST';
export const SAVE_FEEDBACK_SUCCESS = 'SAVE_FEEDBACK_SUCCESS';
export const SAVE_FEEDBACK_FAILURE = 'SAVE_FEEDBACK_FAILURE';

export const SAVE_END_OF_ROAD_MESSAGE = 'SAVE_END_OF_ROAD_MESSAGE';

export const SAVE_HAIRCARE_FEEDBACK_STATUS = 'SAVE_HAIRCARE_FEEDBACK_STATUS';
export const SAVE_SUPPLEMENTS_FEEDBACK_STATUS = 'SAVE_SUPPLEMENTS_FEEDBACK_STATUS';
